// extracted by mini-css-extract-plugin
export default {"overlayWrapper":"Users_overlayWrapper__3q6Wb","details":"Users_details__Dns2g","content":"Users_content__uuxuw","usersPage":"Users_usersPage__rcXCp"};